import React from 'react';
import { ICommentsSection } from './interfaces';
import { Box, Stack } from '@mui/material';
import { BORDER_COLOR } from '../../../../../constants';
import { PostCommentSection } from './components/PostCommentSection';
import { Comment } from './components/Comment';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './styles.css';
import { LoadMoreButton } from './components/LoadMoreButton';
import { usePostCommentMutation } from '@reactQuery/feeds/feed';
import { Loader } from '@components/feed/Loader';

export const CommentsSection: React.FC<ICommentsSection> = ({
  messageId,
  author,
  comments,
  commentsCount = 0,
  loadMoreDisabled,
  isLoading,
  onLoadMore,
  onLikeClick,
}): JSX.Element => {
  const { mutate: postComment, isPending: isPostingComment } =
    usePostCommentMutation();

  const onCommentPost = (message: string): void => {
    if (isPostingComment) {
      return;
    }

    postComment({
      messageId,
      commentParams: {
        body: message,
      },
    });
  };

  return (
    <Box
      sx={{
        borderTop: `1px solid ${BORDER_COLOR}`,
        width: '100%',
      }}
    >
      {author && (
        <PostCommentSection author={author} onCommentPost={onCommentPost} />
      )}
      <Stack>
        <TransitionGroup className="comments-wrapper">
          {comments.map((comment, key) => (
            <CSSTransition key={comment.id} timeout={300} classNames="comment">
              <Comment
                key={key}
                id={comment.id}
                messageId={messageId}
                author={comment.author}
                date={comment.date}
                content={comment.content}
                likesCount={comment.likesCount}
                likedByCurrentUser={comment.likedByCurrentUser}
                onLikeClick={() => onLikeClick(comment.id)}
              />
            </CSSTransition>
          ))}
        </TransitionGroup>
        {isLoading && (
          <div style={{ height: '40px' }}>
            <Loader />
          </div>
        )}
        {comments.length < commentsCount && (
          <LoadMoreButton disabled={loadMoreDisabled} onLoadMore={onLoadMore} />
        )}
      </Stack>
    </Box>
  );
};
